import * as React from 'react';
import { __ } from 'react-i18n';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical } from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';

interface Props {
  title: string;
  value: string;
}

function MobileTitleValue({ title, value }: Props) {
  return (
    <ValueRow>
      <TypeOfValue>{title}</TypeOfValue>
      <Value>{value}</Value>
    </ValueRow>
  );
}

const ValueRow = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${rem(8)};
  border-bottom: ${rem(8)};
`;

const TypeOfValue = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 300;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-right: ${rem(16)};
  overflow: hidden;
  white-space: nowrap;

  &:after {
    color: #ccc;
    margin: 0 ${rem(16)};
    content: '';
    display: inline-block;
    border-bottom: 1px dotted #ccc;
    width: ${rem(300)};
  }
`;

const Value = styled(TextP)`
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  white-space: nowrap;
`;

const Delimeter = styled(TextP)`
  font-weight: 300;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-right: ${rem(32)};
  color: '#ccc';
`;

export { MobileTitleValue };
